//AB TESTS
const PRICE_PER_USER_AB_TEST = "homepage_price_per_user_ab_test";
const NEW_COOKIES_POLICY_AB_TEST = "new_cookies_policy_ab_test";
const SOFT_SIGNUP_TRIAL_CTA_HOMEPAGE_AB_TEST = "soft_signup_trial_cta_homepage_ab_test";
const SOFT_SIGNUP_TRIAL_CTA_LP_AB_TEST = "soft_signup_trial_cta_lp_ab_test";
const SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST = "skip_sign_up_step_in_pricing_page_ab_test";
const WORK_EMAIL_SUGGESTION_AB_TEST = "work_email_suggestion_ab_test";
const DRIFT_PRICING_CHATBOT_CONTACT_SALES_AB_TEST = "drift_pricing_chatbot_contact_sales_ab_test";
const HOMEPAGE_PRICE_PER_SEAT_NEW_AB_TEST = "homepage_price_per_seat_new_ab_test";
const EXIT_POP_UP_SURVEY_AB_TEST = "exit_pop_up_survey_ab_test";
const TRY_FOR_FREE_CTA_AB_TEST = "try_for_free_cta_ab_test";
const HOMEPAGE_PRICE_PER_SEAT_V3_AB_TEST = "homepage_price_per_seat_v3_ab_test";
const MOBILE_CLUSTER_SIGNUP_AB_TEST = "mobile_clusters_soft_signup_ab_test";

const LEARN_MORE_AND_SIGNUP_BUTTON = {
  test_name: "learn_more_and_signup_button",
  new_variation_name: "new_with_learn_more_and_signup_button"
};

const LEARN_MORE_TO_PRODUCT_BUTTON = {
  test_name: "learn_more_to_product_button_new",
  new_variation_name: "new_with_learn_more_to_product_button"
};

const REVIVE_EXIT_POPUP_AB_TEST = {
  test_name: "revive_exit_popup_ab_test",
  new_variation_name: "new_with_exit_popup"
};

const PERFORMANCE_STATIC_PAGE_AB_TEST = {
  test_name: "performance_static_page_ab_test",
  new_variation_name: "new_static_page"
};

const BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES = {
  test_name: "homepage_bigger_storage_in_pricing_page_features",
  new_variation_name: "new_with_bigger_storage"
};

const TEMPLATES_IN_HEADER_AB_TEST = {
  test_name: "homepage_templates_in_header_ab_test",
  new_variation_name: "new_with_templates"
};

const MOBILE_SIGNUP_REMOVE_EMAIL_FIELD_AB_TEST = {
  test_name: "mobile_signup_remove_email_field_ab_test",
  new_variation_name: "new_without_email_field"
};

const HOMEPAGE_V9_PRICING_VERSION_AB_TEST = {
  test_name: "homepage_v9_pricing_version_ab_test",
  new_variation_name: "new_with_v9"
};

const GERMAN_TRY_FOR_FREE_TEST = {
  test_name: "german_try_for_free_cta_ab_test",
  new_variation_name: "new_try_for_free"
};

const DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST = {
  test_name: "desktop_with_enterprise_in_submenu_ab_test",
  new_variation_name: "new_with_enterprise_in_submenu"
};

const MOBILE_TEMPLATE_CENTER_IN_MENU = {
  test_name: "mobile_template_center_in_menu",
  new_variation_name: "new_with_mobile_template_center_in_menu"
};

const HOMEPAGE_HIDE_BASIC_AB_TEST = {
  test_name: "homepage_hide_basic_ab_test",
  new_variation_name: "new_with_hide_basic"
};

const CONSULT_WITH_US_MENU_AB_TEST = {
  test_name: "consult_with_us_menu_ab_test",
  new_variation_name: "new_with_consult_with_us"
};

const HOMEPAGE_PRODUCT_SOLUTIONS_AB_TEST = {
  test_name: "homepage_product_solutions_ab_test",
  new_variation_name: "new_with_product_solutions"
};

const PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST = {
  test_name: "pricing_enterprise_contact_sales_ab_test",
  new_variation_name: "new_enterprise_page"
};

const MOBILE_STICKY_SIGNUP_AB_TEST = {
  test_name: "mobile_sticky_signup_ab_test",
  new_variation_name: "new_with_sticky_signup"
};

const ENRICHMENT_HOMEPAGE_SALES_CTA_AB_TEST = {
  test_name: "enrichment_homepage_sales_cta_ab_test",
  new_variation_name: "new_with_sales_cta"
};

module.exports = {
  PRICE_PER_USER_AB_TEST,
  NEW_COOKIES_POLICY_AB_TEST,
  SOFT_SIGNUP_TRIAL_CTA_HOMEPAGE_AB_TEST,
  SOFT_SIGNUP_TRIAL_CTA_LP_AB_TEST,
  SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST,
  WORK_EMAIL_SUGGESTION_AB_TEST,
  DRIFT_PRICING_CHATBOT_CONTACT_SALES_AB_TEST,
  HOMEPAGE_PRICE_PER_SEAT_NEW_AB_TEST,
  EXIT_POP_UP_SURVEY_AB_TEST,
  LEARN_MORE_AND_SIGNUP_BUTTON,
  LEARN_MORE_TO_PRODUCT_BUTTON,
  HOMEPAGE_PRICE_PER_SEAT_V3_AB_TEST,
  TRY_FOR_FREE_CTA_AB_TEST,
  REVIVE_EXIT_POPUP_AB_TEST,
  PERFORMANCE_STATIC_PAGE_AB_TEST,
  BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES,
  TEMPLATES_IN_HEADER_AB_TEST,
  MOBILE_SIGNUP_REMOVE_EMAIL_FIELD_AB_TEST,
  HOMEPAGE_V9_PRICING_VERSION_AB_TEST,
  GERMAN_TRY_FOR_FREE_TEST,
  DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST,
  MOBILE_CLUSTER_SIGNUP_AB_TEST,
  MOBILE_TEMPLATE_CENTER_IN_MENU,
  HOMEPAGE_HIDE_BASIC_AB_TEST,
  CONSULT_WITH_US_MENU_AB_TEST,
  HOMEPAGE_PRODUCT_SOLUTIONS_AB_TEST,
  PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST,
  MOBILE_STICKY_SIGNUP_AB_TEST,
  ENRICHMENT_HOMEPAGE_SALES_CTA_AB_TEST
};
